import React, { useRef, useContext } from "react";
import { useFrame } from "@react-three/fiber";
import { defaultGrid } from "../js/three-utils";
import { AppContext } from "../contexts/AppContext";
const GridController = () => {
  const gridRef = useRef();
  const axesRef = useRef();
  const { grid } = useContext(AppContext);
  useFrame(() => {
    if (gridRef.current) gridRef.current.rotation.set(Math.PI / 2, 0, 0);
    if (axesRef.current) {
      axesRef.current.position.set(
        -defaultGrid.size / 2,
        -defaultGrid.size / 2,
        0
      );
    }
  });
  return (
    <>
      {grid && (
        <>
          <gridHelper
            ref={gridRef}
            args={[
              defaultGrid.size,
              defaultGrid.divisions,
              `#282828`,
              `#888888`,
            ]}
          />
          <axesHelper ref={axesRef} args={[100]} />
        </>
      )}
    </>
  );
};
export default GridController;
